import clsx from 'clsx';
import { Loader } from 'lucide-react';
import React, { PropsWithChildren } from 'react';

import styles from './styles.module.css';

type Props = {
  readonly disabled?: boolean;
  readonly loading?: boolean;
  readonly onClick?: () => void;
  readonly className?: string;
} & PropsWithChildren;

export const IconButton: React.FC<Props> = props => {
  const handleClick = () => {
    if (!props.disabled) {
      props.onClick && props.onClick();
    }
  };

  return (
    <div
      className={clsx(styles.container, props.className, {
        [styles.active]: !props.disabled,
      })}
      onClick={handleClick}
    >
      {props.loading ? <Loader className={styles.loading} /> : props.children}
    </div>
  );
};
